module.exports = __webpack_public_path__ + "static/media/sminkfest.de0c38d6.png";